import { Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { AppService } from '@mmx/shared'

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(private app: AppService, private title: Title) {}

  setTitle(title: string) {
    return this.title.setTitle(`${this.app.name}: ${title}`)
  }

  getTitle() {
    return this.title.getTitle()
  }
}
